import { tipoff } from "@/lib/format";

const FINAL_DELAY_MS = 3 * 60 * 1000;
const pad = (n) => String(n).padStart(2, "0");

// ESPN status_detail ("5:19 - 4th", "6.5 - 4th", "2:31 - OT") -> period, seconds left and a "Q4 - 05:19" label.
export function liveClock(detail = "") {
  const m = detail.match(/^([\d:.]+)\s*-\s*(?:(\d)(?:st|nd|rd|th)|(\d*)OT)$/i);
  if (!m) return { label: detail.toUpperCase(), period: null, seconds: null };
  const [mm, ss] = m[1].includes(":") ? m[1].split(":").map(Number) : [0, Math.floor(Number(m[1]))];
  const period = m[2] ? Number(m[2]) : 4 + (Number(m[3]) || 1);
  const name = period > 4 ? `OT${period > 5 ? period - 4 : ""}` : `Q${period}`;
  return { label: `${name} - ${pad(mm)}:${pad(ss)}`, period, seconds: mm * 60 + ss };
}

export function gameTime(g) {
  if (g.status === "post") return { label: "FINAL", critical: false };
  if (g.status === "in") {
    const c = liveClock(g.status_detail);
    return { label: c.label, critical: c.period != null && c.period >= 4 && c.seconds <= 300 };
  }
  return { label: g.status === "ppd" ? "PPD" : tipoff(g.date_utc), critical: false };
}

// Starred games first, then finished games go to the end 3 minutes after the server's final timestamp.
const moved = (g, now) => g.status === "post" && g.final_at && now - new Date(g.final_at).getTime() >= FINAL_DELAY_MS;
export const orderGames = (games, now, fav = new Set()) => [...games].sort((a, b) =>
  fav.has(b.id) - fav.has(a.id) || moved(a, now) - moved(b, now) || a.date_utc.localeCompare(b.date_utc));
